"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _ActionNamespaces = require("./ActionNamespaces");

var _ActionVerbs = require("./ActionVerbs");

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _MakeActions = require("./MakeActions");

/**
 * All the actionTypes used by flux actionCreators, services, and stores in crm_data.
 *
 * These keys should be declared in _ABC order_.
 */
var _default = (0, _keyMirror.default)((0, _extends2.default)({}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.ACCOUNTING_EXTENSIONS, _ActionVerbs.FETCH), {
  ACCOUNTING_NEW_CUSTOMER_UPDATE: null,
  ACTIVITY_TYPES_UPDATED: null,
  ASSOCIATIONS_REFRESH_QUEUED: null,
  AUTH_LOADED: null,
  BET_PORTAL_OBJECT_ASSOCIATIONS_ADD: null,
  BET_PORTAL_OBJECT_ASSOCIATIONS_FETCH: null,
  BET_PORTAL_OBJECT_ASSOCIATIONS_REMOVE: null,
  BET_SERVICE_OBJECT_ASSOCIATIONS_ADD: null,
  BET_SERVICE_OBJECT_ASSOCIATIONS_FETCH: null,
  BET_SERVICE_OBJECT_ASSOCIATIONS_REMOVE: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.CALL_PROVIDERS, _ActionVerbs.FETCH), {
  CALL_WIDGET_CALL_ACTIVE: null,
  CALL_WIDGET_DATA_RECEIVED: null,
  CALL_WIDGET_HIDE: null,
  CALL_WIDGET_MINIMIZE: null,
  CALL_WIDGET_READY: null,
  CALL_WIDGET_RESET_STATE: null,
  CALL_WIDGET_RINGING: null,
  CALL_WIDGET_TIMED_OUT: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.COMPANIES, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.COMPANIES, _ActionVerbs.UPDATE), {
  COMPANIES_REFRESH_QUEUED: null,
  COMPANIES_SEARCH_LOADING: null,
  COMPANIES_SEARCH_SYNCED: null,
  COMPANIES_UPDATED: null,
  COMPANIES_VIEW_SYNCED: null,
  COMPANY_CREATED: null,
  COMPANY_DOMAIN_FOUND: null,
  COMPANY_DOMAIN_NOT_FOUND: null,
  COMPANY_DOMAIN_REMOVED: null,
  COMPANY_PARENT_ADD_CHILD: null,
  COMPANY_PARENT_REMOVE_CHILD: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.CONTACTS, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.CONTACTS, _ActionVerbs.UPDATE), {
  CONTACT_CREATED: null,
  CONTACT_EMAIL_REMOVED: null,
  CONTACTS_REFRESH_QUEUED: null,
  CONTACTS_REMOVED_FROM_LIST: null,
  CONTACT_SECONDARY_EMAIL_ADDED: null,
  CONTACT_SECONDARY_EMAIL_PROMOTED: null,
  CONTACT_SECONDARY_EMAIL_REMOVED: null,
  CONTACT_SECONDARY_EMAIL_UPDATED: null,
  CONTACT_SET: null,
  CONTACTS_UPDATED: null,
  CONVERSATION_FETCH_HISTORY_SUCCESS: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.CREATOR_PROPERTIES, _ActionVerbs.UPDATE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.CURRENT_OWNER_ID, _ActionVerbs.FETCH), {
  DEAL_CREATED: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.DEAL_PIPELINES, _ActionVerbs.FETCH), {
  DEAL_PIPELINE_SEARCH_RESULT_EXPIRED: null,
  DEAL_STAGE_CHANGE: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.DEALS, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.DEALS, _ActionVerbs.UPDATE), {
  DEALS_REFRESH_QUEUED: null,
  DEALS_UPDATED: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.DEAL_STAGE_PROPERTIES, _ActionVerbs.UPDATE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.DEAL_AUTOMATION, _ActionVerbs.CREATE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.DEAL_AUTOMATION, _ActionVerbs.DELETE), {
  DEFAULT_VIEW_UPDATED: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.EMAIL_RECIPIENT_DELIVERABILTY, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.ENGAGEMENTS, _ActionVerbs.FETCH), {
  ENGAGEMENTS_UPDATED: null,
  ENGAGEMENTS_ATTACHMENTS_UPDATED: null,
  FOLLOW_PROFILE_TOGGLE_FOLLOW: null,
  PIPELINE_UPDATED: null,
  PIPELINE_DELETED: null,
  PIPELINES_UPDATED: null,
  EMAIL_ALIAS_SIGNATURE_UPDATED: null,
  EMAIL_LAWFUL_BASIS_ADDED: null,
  EMAIL_LAWFUL_BASIS_COMPLETE: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.LEGACY_ACTIVE_OWNERS, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.OWNERS, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.OWNER_IDS_BY_EMAIL, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.OWNER_IDS_BY_REMOTE_ID, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.OWNERS, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.OWNERS, _ActionVerbs.UPDATE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.OWNERS_SEARCH, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.IMPORT_NAMES, _ActionVerbs.FETCH), {
  ENGAGEMENT_ASSOCIATIONS_DELETE: null,
  ENGAGEMENT_ASSOCIATIONS_MERGE: null,
  ENGAGEMENT_ASSOCIATIONS_MERGE_AND_UPDATE: null,
  ENGAGEMENT_ASSOCIATIONS_REFRESH: null,
  ENGAGEMENT_ASSOCIATIONS_RESTORE_CALL_ASSOCIATIONS: null,
  ENGAGEMENT_ASSOCIATIONS_UPDATE: null,
  ES_DATA_UPDATED: null,
  ES_RESULT_MOVED: null,
  ES_VIEW_UPDATED: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.ES, _ActionVerbs.FETCH), {
  MEETING_DETAILS_UPDATED: null,
  LIST_CREATE_SUCCEEDED: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.LIST_USAGE, _ActionVerbs.FETCH), {
  LIST_PREVIEW_CANCEL: null,
  LIST_PREVIEW_CREATE: null,
  LIST_PREVIEW_UPDATE: null,
  LIST_SEARCH_CACHE_UPDATED: null,
  LIST_UPDATE_STARTED: null,
  LIST_UPDATE_SUCCEEDED: null,
  LIST_UPDATE_FAILED: null,
  LIST_VALIDATE_SUCCEEDED: null,
  LIST_VALIDATE_FAILED: null,
  LISTS_FETCH_SUCCEEDED: null,
  MAXIMIZE_LINKED_IN_NAVIGATOR: null,
  MINIMIZE_LINKED_IN_NAVIGATOR: null,
  HIDE_LINKED_IN_NAVIGATOR: null,
  SHOW_LINKED_IN_NAVIGATOR: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.MEETINGS_LINKS, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.MEETINGS_USER, _ActionVerbs.FETCH), {
  MEETINGS_USER_UNAVAILABLE: null,
  OBJECT_ASSOCIATION_SUCCEEDED: null,
  OBJECT_DISASSOCIATION_SUCCEEDED: null,
  RELATED_ITEMS_OBJECT_ASSOCIATION_SUCCEEDED: null,
  RELATED_ITEMS_OBJECT_ASSOCIATION_FAILED: null,
  RELATED_ITEMS_OBJECT_DISASSOCIATION_SUCCEEDED: null,
  RELATED_ITEMS_OBJECT_DISASSOCIATION_FAILED: null,
  SALESFORCE_RATE_LIMIT: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.SALESFORCE_RATE_LIMIT, _ActionVerbs.UPDATE), {
  SALESFORCE_INCLUSION_LIST: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.SALESFORCE_INCLUSION_LIST, _ActionVerbs.UPDATE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.SALESFORCE_INCLUSION_LIST, _ActionVerbs.DELETE), {
  SEGMENTS_DUPLICATE_FAILED: null,
  SEGMENTS_DUPLICATE_STARTED: null,
  SEGMENTS_DUPLICATE_SUCCEEDED: null,
  SEGMENTS_FETCH_STARTED: null,
  SEGMENTS_FETCH_SUCCEEDED: null,
  SEGMENTS_MOVE_FAILED: null,
  SEGMENTS_MOVE_STARTED: null,
  SEGMENTS_MOVE_SUCCEEDED: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.SEGMENTS, _ActionVerbs.DELETE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.SEGMENTS_CONTACT_MATCH_CHECK, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.SEGMENTS_FOLDERS, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.SEGMENTS_FOLDERS, _ActionVerbs.CREATE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.SEGMENTS_FOLDERS, _ActionVerbs.DELETE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.SEGMENTS_FOLDERS, _ActionVerbs.UPDATE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.SEGMENTS_SEARCH, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.STRIPE_INTEGRATION, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.TICKET_AUTOMATION, _ActionVerbs.CREATE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.TICKETS, _ActionVerbs.CREATE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.TICKETS, _ActionVerbs.UPDATE), {
  TICKETS_REFRESH_QUEUED: null,
  TICKET_STAGE_CHANGE: null,
  TICKETS_UPDATED: null,
  TICKET_STAGE_CHANGE_REVERT: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.TICKET_PIPELINES, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.TICKET_PIPELINES, _ActionVerbs.UPDATE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.TICKET_PIPELINES, _ActionVerbs.CREATE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.TICKET_PIPELINES, _ActionVerbs.DELETE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.TICKET_PIPELINES, _ActionVerbs.REORDER), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.TICKET_STAGE_PROPERTIES, _ActionVerbs.UPDATE), {
  TIMELINE_COMMENT_CREATED: null,
  TIMELINE_COMMENT_EDITED: null,
  TIMELINE_COMMENT_DELETED: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.FAVORITE_LISTS, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.FAVORITE_LISTS, _ActionVerbs.UPDATE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.LIST_REFS, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.OUTLOOK_PLUGIN, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.PROPERTIES, _ActionVerbs.CREATE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.PROPERTIES, _ActionVerbs.FETCH), {
  QUEUES_CACHE_UPDATED: null,
  QUEUES_FETCH_STARTED: null,
  QUEUES_FETCH_SETTLED: null,
  QUEUES_MERGE_QUEUES: null,
  QUEUES_QUEUE_DELETED: null,
  QUEUES_SET_QUEUE: null,
  TASK_PLAYLIST_GET_STORED_QUERY: null,
  TASK_PLAYLIST_GET_TASKS: null,
  TASK_PLAYLIST_GET_MORE_TASKS: null,
  TASK_PLAYLIST_SET_SEARCH_RESULTS: null,
  TASK_PLAYLIST_ERROR: null,
  REVERT_DEAL_STAGE_MOVE: null,
  REVERT_SETTING: null,
  SET_SETTING: null,
  DELETE_SETTING: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.ACCOUNTS, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.SIDEKICK_PORTAL, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.SIDEKICK_PORTAL, _ActionVerbs.UPDATE), {
  TIMELINE_INTEGRATION_FETCH_INTEGRATION_EVENT_SUCCESS: null,
  TIMELINE_INTEGRATION_FETCH_INTEGRATION_EVENT_FAIL: null,
  TIMELINE_INTEGRATION_START_INTEGRATION_EVENT_FETCH: null,
  TIMELINE_INTEGRATION_REMOVE_INTEGRATION_EVENT: null,
  TIMELINE_INTEGRATION_REMOVE_ALL_INTEGRATION_EVENTS: null,
  USER_SETTINGS_SAVE_FAILED: null,
  USER_SETTINGS_SAVED: null,
  VIEW_DELETED: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.VISITS, _ActionVerbs.REFRESH), {
  VISITS_UPDATED: null,
  ADD_ENGAGEMENT: null,
  ADD_LINE_ITEMS: null,
  ADD_SAMPLE_TIMELINE_ITEMS: null,
  CHANGE_FILTER: null,
  CLEAR_ALL_FILTERS: null,
  TIMELINE_CLEAR_FILTERS: null,
  TIMELINE_CHANGE_USER_AND_TEAM_FILTER: null,
  CLEAR_FAVORITE_EVENT_OVERRIDE: null,
  CLICK_TIMELINE_ITEM: null,
  DELETE_RECORDING: null,
  DELETE_TIMELINE_ENGAGEMENT: null,
  ENABLE_FAVORITE_EVENT: null,
  FETCHING_INITIAL_TIMELINE_EVENTS_STARTED: null,
  FETCH_NEXT_TIMELINE_EVENTS_STARTED: null,
  FETCH_TIMELINE_ITEMS_ERROR: null,
  FETCH_TIMELINE_ITEMS_FOR_VFP_STARTED: null,
  FETCH_TIMELINE_ITEMS_FOR_VFP_SUCCESS: null,
  FETCH_TIMELINE_ITEMS_SUCCESS: null,
  HOVER_ITEM: null,
  NAVIGATE: null,
  POLLING_FETCH_TIMELINE_ITEMS_ERROR: null,
  POLLING_FETCH_TIMELINE_ITEMS_STARTED: null,
  POLLING_FETCH_TIMELINE_ITEMS_SUCCESS: null,
  REMOVE_LINE_ITEM: null,
  RESET_LINE_ITEM_EDITOR_STORE: null,
  SET_FAVORITE_EVENT_OVERRIDE: null,
  UPDATE_LINE_ITEM: null,
  UPDATE_LINE_ITEM_PROPERTY: null,
  REORDER_LINE_ITEM: null,
  SET_LINE_ITEM_ORDER: null,
  STAGE_LINE_ITEMS_FOR_EDIT: null,
  SUBSCRIPTION_RELATIONSHIP_UPDATE_SUCCEEDED: null,
  SUBSCRIPTION_RELATIONSHIP_UPDATES_SUCCEEDED: null,
  SUBSCRIPTION_RELATIONSHIP_FETCH_SUCCEEDED: null,
  CLOSE_FULLSCREEN_COMMUNICATOR: null,
  HIDE_COMMUNICATOR: null,
  MAXIMIZE_COMMUNICATOR: null,
  MINIMIZE_COMMUNICATOR: null,
  OPEN_FULLSCREEN_COMMUNICATOR: null,
  SET_COMMUNICATOR_INITIAL_CONTENT: null,
  SET_COMMUNICATOR_TRIGGER_LOCATION: null,
  SHOW_COMMUNICATOR: null,
  SET_CALLEE: null,
  SET_CALL_PROVIDER: null,
  SET_SHOULD_START_CALL_ON_LOAD: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.FAVORITE_VIEWS_USER, _ActionVerbs.UPDATE), {
  LINE_ITEMS_REFRESH_QUEUED: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.LINE_ITEMS, _ActionVerbs.CREATE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.LINE_ITEMS, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.LINE_ITEMS, _ActionVerbs.UPDATE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.LINE_ITEMS, _ActionVerbs.DELETE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.LINE_ITEMS_BULK, _ActionVerbs.UPDATE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.PRODUCTS_SEARCH, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.PRODUCTS_SEARCH_LOAD_MORE, _ActionVerbs.FETCH), {
  STAGE_QUOTE_FOR_EDIT: null,
  SET_DEFAULT_QUOTE_PROPERTIES: null,
  UPDATE_QUOTE_PROPERTY: null,
  UPDATE_QUOTE_PROPERTIES: null,
  SET_QUOTE_ASSOCIATIONS: null,
  RESET_QUOTE_EDITOR: null,
  ADD_CONTACT_SIGNER: null,
  REMOVE_CONTACT_SIGNER: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.QUOTES, _ActionVerbs.CREATE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.QUOTES, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.QUOTE_BY_ID, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.QUOTES, _ActionVerbs.UPDATE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.QUOTES, _ActionVerbs.DELETE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.QUOTES, _ActionVerbs.APPROVE), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.QUOTES, _ActionVerbs.REQUEST_CHANGES), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.QUOTES_BY_DEAL_ID, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.TICKET_FORMS, _ActionVerbs.CREATE), {
  TICKET_FORMS_FORM_ALREADY_EXISTS: null
}, (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.PLAYBOOKS, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.CALL_TRANSCRIPTIONS, _ActionVerbs.FETCH), (0, _MakeActions.makeAsyncActionConstants)(_ActionNamespaces.CONTENTS, _ActionVerbs.FETCH), {
  OPEN_PLAYBOOK: null,
  CLOSE_PLAYBOOK: null,
  MAXIMIZE_PLAYBOOK: null,
  MINIMIZE_PLAYBOOK: null,
  PLAYBOOKS_REQUEST_ASSOCIATIONS: null,
  UPDATE_OPTIN_STATUS: null,
  CONTACTS_CLEARED: null,
  COMPANIES_CLEARED: null,
  DEALS_CLEARED: null,
  LINE_ITEMS_CLEARED: null,
  ASSOCIATIONS_CLEARED: null
}));

exports.default = _default;
module.exports = exports.default;